<!--
 * @Author: guoyu
 * @Date: 2020-05-27 11:39:44
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 15:20:42
 * @Description: 刚进入抢单页面倒计时提示动画
-->
<template>
  <CountdownPopup
    class="start-popup"
    v-model="show"
    :class="{ 'animate-go-top': startMove }"
    :overlay="false"
  >
    <Countdown
      class="popup-countdown"
      :timestamp="timestamp"
      background="#F06950"
      :prefixColor="'#ffffff'"
    ></Countdown>
    <div class="alert-text">{{$t('upgrade_page_views_quick_order_count_down_start_animate_2129')}}<br /><span class="use-times">{{$t('upgrade_page_views_quick_order_count_down_start_animate_2130')}}</span
      >{{$t('upgrade_page_views_quick_order_count_down_start_animate_2131')}}</div>
  </CountdownPopup>
</template>
<script>
import { Popup } from 'mint-ui';
import Countdown from './count-down';
export default {
  components: {
    CountdownPopup: Popup,
    Countdown,
  },
  props: {
    timestamp: Number,
    background: {
      type: String,
      default: '#323D4F',
    },
  },
  data() {
    return {
      show: false,
      startMove: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 300);
    setTimeout(() => {
      this.startMove = true;
    }, 5000);
    setTimeout(() => {
      this.$emit('animateEnd');
    }, 5250);
  },
};
</script>
<style lang="scss" scoped>
.start-popup {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: scale(1) translate(-50%, -50%);
  width: 387px;
  height: 217px;
  padding: 0 25px;
  border-radius: 11px;
  text-align: center;
  font-size: 16px;
  background: rgba(30, 30, 30, 0.75);
  backdrop-filter: blur(30px);
  color: #ffffff;
}
.alert-text {
  margin-top: 20px;
  line-height: 26px;
  .use-times {
    color: #fdbe86;
  }
}

.popup-countdown {
  display: flex;
  justify-content: center;
  font-size: 36px;
  /deep/ .block {
    width: 58px;
    height: 52px;
    margin: 0 12px;
    border-radius: 8px;
    line-height: 36px;
  }
}
.animate-go-top {
    transform: scale(0.1) translate(-50%, -50%);
    top: -50px;
    left: 10%;
    transition: all 0.3s ease-out;
}
@media screen and(min-width: 600px) {
  .animate-go-top {
    transform: scale(0.1) translate(-50%, -50%);
    top: -50px;
    left: 980px;
    transition: all 0.3s ease-out;
  }
}

</style>
